import { render, staticRenderFns } from "./autoCreacionStep2.vue?vue&type=template&id=4aeb5ca8&scoped=true&"
import script from "./autoCreacionStep2.vue?vue&type=script&lang=js&"
export * from "./autoCreacionStep2.vue?vue&type=script&lang=js&"
import style0 from "./autoCreacionStep2.vue?vue&type=style&index=0&id=4aeb5ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb5ca8",
  null
  
)

export default component.exports